export default "__VITE_PUBLIC_ASSET__b73c2c40__"